import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useMemo,
} from 'react';
import {
	defaultColDefination,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getNonPreferdSuppliers } from 'utils/apiRequests';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { formatNumber } from 'utils/number';
import { getHeaderByTaxonomyType } from '../../CategoryManagement/utils';

const NonPreferedSuppliersContext = createContext();

const suppliersText = 'suppliers';

export const NonPreferedSuppliersProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`X ${suppliersText}`);

	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		segmentationUpdatedCount,
		isDirect,
		isSourceable,
		taxonomyType,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	const taxonomyHeader = useMemo(() => getHeaderByTaxonomyType(taxonomyType), [
		taxonomyType,
	]);

	const columnDefs = [
		{ headerName: 'Vendor Name', field: 'vendor_Name' },
		{ headerName: 'Is Prefered', field: 'is_Preferred', hide: true },
		{ headerName: `${taxonomyHeader} L1Category`, field: 'l1Category' },
		{ headerName: `${taxonomyHeader} L2Category`, field: 'l2Category' },
		{ headerName: `${taxonomyHeader} L3Category`, field: 'l3Category' },
		{ headerName: `${taxonomyHeader} L4Category`, field: 'l4Category' },
		{ headerName: 'Business Unit', field: 'bussiness_Units' },
		{ headerName: 'Vendor Segmentation', field: 'vendor_Segmentation' },
		{ headerName: 'Contracts', field: 'contracts' },
		{ headerName: 'Country', field: 'country', hide: true },
		{ headerName: 'Year', field: 'year', hide: true },
	];

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					getNonPreferdSuppliers(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data.length > 0 || response.data !== null) {
									if (!!Object.keys(response.data).length) {
										if (response.data.explore.length > 0) {
											const analysisString = `${formatNumber(
												response.data.nonPreferredCount
											)} ${suppliersText}`;
											setAnalysis(analysisString);
											setGridData(prevState => ({
												...prevState,
												rowData: response.data.explore,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
										} else {
											setAnalysis(`0 ${suppliersText}`);
										}
										setIsLoading(false);
									}
								} else {
									setIsLoading(false);
								}
							} else {
								setAnalysis('Supplier not present.');
								setGridData(initialGridData);
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			segmentationUpdatedCount,
			isDirect,
			isSourceable,
			taxonomyType,
		]
	);

	return (
		<NonPreferedSuppliersContext.Provider
			value={{ isLoading, analysis, gridData }}
		>
			{children}
		</NonPreferedSuppliersContext.Provider>
	);
};

export const useNonPreferedSuppliersContext = () => {
	return useContext(NonPreferedSuppliersContext);
};
